import React, { Fragment } from "react";
import PropTypes from "prop-types";
import Form from "../../common/Form";
import Fieldset from "../../common/Fieldset";
import JaNeeRadioButtonGroup from "../../common/JaNeeRadioButtonGroup";
import ToegankelijkheidPerAfstand from "./parts/ToegankelijkheidPerAfstand";
import KinderenComponent from "./parts/KinderenComponent";
import VoorzieningenComponent from "./parts/VoorzieningenComponent";
import Row from "../../common/Row";
import Confirm from "../../common/Confirm";
import TextAreaInput from "../../common/TextAreaInput";
import SocialeMedia from "../publicatie/parts/SocialeMedia";
import { TochtRedenVanStatus } from "../../../constants/DomainConstants";

const PublicatieForm = (props) => {
    const {
        model,
        onChange,
        onSave,
        getError,
        disabled,
        color,
        validationMessageType,
        onChangeRadio,
        onChangeSubcomponent,
        showVoorzieningenPopup,
        onConfirmVoorzieningenPopup
    } = props;

    const isDoorgestuurdTerGoedkeuring = model.redenVanStatus === TochtRedenVanStatus.DoorgestuurdTerGoedkeuring;
    const toonPublicatieGegevens = model["startplaatsGemeenteAccount"] != "00000000-0000-0000-0000-000000000000" && (model["publicatieOpWebsiteSportVlaanderen"] === "true" || model["publicatieOpWebsiteSportVlaanderen"] === true);

    return (
        <Fragment>
            {!showVoorzieningenPopup
                ||
                <Confirm
                    message={"Sport Vlaanderen adviseert aparte kleedkamers en douches voor mannen en vrouwen"}
                    title={"Voorzieningen"}
                    callback={onConfirmVoorzieningenPopup}
                    confirmText="OK"
                    hideCancel
                />}
            <Form name="Publicatie"
                title={"Invulformulier publicatie"}
                headerVisible={false}
                leftButtonLabel={"Bewaar"}
                onLeftButtonClick={onSave}
                leftButtonDisabled={disabled}
                color={color}>
                <Fieldset title={"Toestemmingen"} key={"toestemmingen"}>
                    <JaNeeRadioButtonGroup
                        label="Mogen de contactgegevens van de organisator overgenomen worden door de afnemers van GIPOD?"
                        name="toestemmingPublicatieGipodEnGeopunt"
                        value={model["toestemmingPublicatieGipodEnGeopunt"]}
                        onChange={onChangeRadio}
                        horizontal
                        labelInside
                        disabled={disabled || isDoorgestuurdTerGoedkeuring}
                        validationMessage={getError("toestemmingPublicatieGipodEnGeopunt")}
                        validationMessageType={validationMessageType}
                        tooltip={'Wanneer je hiervoor toestemming geeft, worden het E-mailadres en telefoonnummer van de contactpersoon getoond in GIPOD (Geplande mobiliteitshinder op openbaar domein) : https://www.geopunt.be/hinder-in-kaart'}
                    />
                    <JaNeeRadioButtonGroup
                        label="Mag deze tocht gepubliceerd worden op de website van Sport Vlaanderen?"
                        name="publicatieOpWebsiteSportVlaanderen"
                        value={model["publicatieOpWebsiteSportVlaanderen"]}
                        onChange={onChangeRadio}
                        horizontal
                        labelInside
                        disabled={disabled}
                        validationMessage={getError("publicatieOpWebsiteSportVlaanderen")}
                        validationMessageType={validationMessageType}
                    />
                    {toonPublicatieGegevens ?
                        <JaNeeRadioButtonGroup
                            label="Mag deze tocht gepubliceerd worden op de website van UiT in Vlaanderen?"
                            name="publicatieOpWebsiteUitInVlaanderen"
                            value={model["publicatieOpWebsiteUitInVlaanderen"]}
                            onChange={onChangeRadio}
                            horizontal
                            labelInside
                            disabled={disabled}
                            validationMessage={getError("publicatieOpWebsiteUitInVlaanderen")}
                            validationMessageType={validationMessageType}
                        />
                        : null}
                </Fieldset>
                {toonPublicatieGegevens ?

                    [
                        <Fieldset title="Beschrijving van je tocht" key={"beschrijvingVanDeTocht"}>
                            <Row>
                                <TextAreaInput
                                    name="beschrijvingVanDeTocht"
                                    label="Korte omschrijving (max 500 tekens)"
                                    value={model.beschrijvingVanDeTocht}
                                    onChange={onChange}
                                    validationMessage={getError("beschrijvingVanDeTocht")}
                                    validationMessageType={validationMessageType}
                                    disabled={disabled}
                                    optional
                                    maxLength={500}
                                    height={7}
                                />
                            </Row>
                        </Fieldset>,
                        <SocialeMedia
                            key={"SocialeMedia"}
                            disabled={disabled}
                            onChange={onChange}
                            model={model}
                            getError={getError}
                            validationMessageType={validationMessageType} />,
                        <KinderenComponent
                            key={"KinderenComponent"}
                            model={model}
                            disabled={disabled}
                            onChange={onChangeSubcomponent}
                            getError={getError}
                        />,
                        <ToegankelijkheidPerAfstand
                            key={"ToegankelijkheidPerAfstand"}
                            model={model}
                        />,
                        <VoorzieningenComponent
                            key={"VoorzieningenComponent"}
                            model={model}
                            disabled={disabled}
                            onChange={onChangeSubcomponent}
                            getError={getError}
                        />,
                        <Fieldset title={"Voorzieningen onderweg"} key={"Voorzieningen onderweg"}>
                            <Row>
                                <JaNeeRadioButtonGroup
                                    label="Pechdienst"
                                    name="pechdienst"
                                    value={model["pechdienst"]}
                                    optional
                                    onChange={onChangeRadio}
                                    size={6}
                                    horizontal
                                    labelInside
                                    disabled={disabled}
                                    validationMessage={getError("pechdienst")}
                                    validationMessageType={validationMessageType}
                                />
                                <JaNeeRadioButtonGroup
                                    label="Bevoorrading"
                                    name="bevoorrading"
                                    value={model["bevoorrading"]}
                                    optional
                                    onChange={onChangeRadio}
                                    size={6}
                                    horizontal
                                    labelInside
                                    disabled={disabled}
                                    validationMessage={getError("bevoorrading")}
                                    validationMessageType={validationMessageType}
                                />
                            </Row>
                        </Fieldset>]
                    : null
                }
            </Form>
        </Fragment>);
};

PublicatieForm.propTypes = {
    model: PropTypes.array,
    onChange: PropTypes.func.isRequired,
    onChangeRadio: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    getError: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    readonly: PropTypes.bool,
    color: PropTypes.string,
    validationMessageType: PropTypes.string,
    onChangeSubcomponent: PropTypes.func,
    showVoorzieningenPopup: PropTypes.bool,
    onConfirmVoorzieningenPopup: PropTypes.func
};

export default PublicatieForm;